import { ContentLayout } from "@/components/Layout";
import { Authorization, ROLES } from "@/libs/authorization";

import { Permissions, Settings } from "../components";

export const AdminSetting = () => {
  return (
    <ContentLayout title="Settings">
      <div className="bg-white flex mb-6 rounded-2xl flex-col dark:bg-slate-900/70">
        <div className="flex-1">
          <Authorization
            forbiddenFallback={<div>Only Admin can view this.</div>}
            allowedRoles={[ROLES.ADMIN]}
          >
            <Settings />
            <h2 className="leading-tight text-2xl">Permissions</h2>
            <Permissions />
          </Authorization>
        </div>
      </div>
    </ContentLayout>
  );
};
